import request from "@/utils/request";
import{Local} from '@/utils/storage'


//收益数据
export function dwmIncomeData(){
    let path = "/user/mechanismAccount/dwmIncomeData"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        
    }
    if(!['机构', 'mec_manager'].includes(Local.get('type'))){
        param.invest_id = Local.get("managerInfo").id
    }
    return request.get(path,param)
}


//课程数量统计图
export function courseNumLineEcharts(data:EmptyObjectType){
    let path = "/user/coopMechanismRelative/courseNumLineEcharts"
    let param:any = {}
    if(['机构', 'mec_manager'].includes(Local.get('type'))){
        param.parent_id = Local.get("current_mechanism").id
    }else{
        param.mechanism_id = Local.get("current_mechanism").id,
        param.invest_id = Local.get("managerInfo").id
    }
    param = {
        ...param,
        ...data
    }
    return request.get(path,param)
}


//上课人数统计图
export function personLineEcharts(data:EmptyObjectType){
    let path = "/user/coopMechanismRelative/personLineEcharts"
    let param:any = {}
    if(['机构', 'mec_manager'].includes(Local.get('type'))){
        param.parent_id = Local.get("current_mechanism").id
    }else{
        param.mechanism_id = Local.get("current_mechanism").id,
        param.invest_id = Local.get("managerInfo").id
    }
    param = {
        ...param,
        ...data
    }
    return request.get(path,param)
}

//课程类目统计
export function courseCategoryLineEcharts(data:EmptyObjectType){
    let path = "/user/coopMechanismRelative/courseCategoryLineEcharts"
    let param:any = {}
    if(['机构', 'mec_manager'].includes(Local.get('type'))){
        param.parent_id = Local.get("current_mechanism").id
    }else{
        param.mechanism_id = Local.get("current_mechanism").id,
        param.invest_id = Local.get("managerInfo").id
    }
    param = {
        ...param,
        ...data
    }
  
    return request.get(path,param)
}


//收益统计图
export function incomeLineEcharts(data:EmptyObjectType){
    let path = "/user/mechanismAccount/incomeLineEcharts"
    let param:any = {
        ...data,
        mechanism_id: Local.get("current_mechanism").id,
    }
    if(!['机构', 'mec_manager'].includes(Local.get('type'))){
        param.invest_id = Local.get("managerInfo").id
    }
  
    return request.get(path,param)
}



//创建班级
export function createClass(data:EmptyObjectType){
    let path = "/user/mechanismClasses/unionCreateClass"
    let param = {
        ...data,
        mechanism_id: Local.get("current_mechanism").id,
    }
  
    return request.post(path,param)
}

//解散班级
export function cancelClass(id: number|string){
    let path = "/user/mechanismClasses/cancelClass"
    let param = {
        id
    }

    return request.post(path,param)
}

//删除班级的学员
export function delClassStus(data:EmptyObjectType){
    let path = "user/mechanismClasses/delByStudycardIds"
    return request.post(path,data)
}

//添加班级您的学员
export function addClassStus(data:EmptyObjectType){
    let path = "/user/mechanismClasses/addByStudycardIds"
    return request.post(path,data)
}


// 管理员信息
export function adminInfo(id:number){
    let path = '/authorization/managerUser/findById'
    let param = {
       id : id,
    } 
    return request.get(path,param)
}


// 合作商的店铺
export function getInvestorMechanismList(){
    let path = '/user/mechanismInvest/getInvestorMechanism'
    let param = {
        admin_id: Local.get("managerInfo").id
    } 
    return request.get(path,param)
}


// 获取合作商或者机构的进度信息
export function getCoopEventMessage(data:EmptyObjectType){
    let path = '/user/eventMessage/queryListPage'
    let param = {
       ...data,
       mechanism_id: Local.get("current_mechanism").id,
    } 

    return request.get(path,param)
}

//获取类目
export function queryCategoryChild(name?:string){
    let path = "/user/mechanismCategory/queryListPageChild"
    let param = {
        status: 2,
        type: 2,
        source: name || "课程",
    } 

    return request.get(path,param)
}


//收益数据
export function mallIndexData(){
    let path = "/user/mastermechanism/mallBoard"
    let param = {
        type: 'mall',
        id: Local.get("current_mechanism").id,
        mechanism_id: Local.get("managerInfo").mechanism_id //父机构
    }
    return request.get(path,param)
}


//收益统计图
export function mallIncomeLineEcharts(data:EmptyObjectType){
    let path = "/user/mechanismAccount/incomeLineEcharts"
    let param : any= {
        mechanism_id: Local.get("managerInfo").mechanism_id,
    }
    if(param.mechanism_id != Local.get("current_mechanism").id){
        param.form_mec = Local.get("current_mechanism").id
    }
    param = {
        ...param,
        ...data,
    }
  
    return request.get(path,param)
}

/**
 * 商场课节数排行
 * @param {Object} param
 */
 export function mallAppoRank(param:EmptyObjectType) {
	param.mechanism_id = Local.get("managerInfo").mechanism_id
    let path =  "/user/stat/mallAppoRank"
    return request.get(path,param)
}

/**
 * 商场收益排行
 * @param {Object} param
 */
export function mallIncomeRank(param:EmptyObjectType) {
	param.mechanism_id = Local.get("managerInfo").mechanism_id
    let path = "/user/stat/mallIncomeRank"
    return request.get(path,param)
}


/**
 * 收益统计
 * @param {Object} param
 */
 export function enrollIncomeEcharts(param:EmptyObjectType) {
    param.admin_id = Local.get("managerInfo").id
    let path = "/user/stat/enrollIncomeEcharts"
    return request.get(path,param)
}

/**
 * 邀请统计
 * @param {Object} param
 */
export function enrollInviteEcharts(param:EmptyObjectType) {
    param.admin_id = Local.get("managerInfo").id
    let path = "/user/stat/enrollInviteEcharts"
    return request.get(path,param)
}

/**
 * 门店订单统计
 * @returns 
 */
export function mecOrderEcharts(param:any){
    let data = {
        mechanism_id: Local.get("current_mechanism").id,
        ...param
    }
    let path = "/user/stat/mecOrderEcharts"
    return request.get(path,data)
}

//收益数据
export function enrollIndexData(){
    let path = "/user/stat/enrollToday"
    let param = {
        admin_id: Local.get("managerInfo").id,
        mode: 'm'
    }
    return request.get(path,param)
}


//商场大屏数据看板
export function mallAllDataBoard(){
    let path = "/user/stat/mallBoard"
    let param = {
        mechanism_id: Local.get("managerInfo").mechanism_id
    }
    return request.get(path,param)
}


//商场数据
export function mallMecData(data:any){
    let path = "/user/stat/mallMecData"
    let param = {
        mechanism_id: Local.get("managerInfo").mechanism_id,
        ...data
    }
    return request.get(path,param)
}


//商场数据
export function mallMecCourseData(data:any){
    let path = "/user/stat/mallMecCourseData"
    let param = {
        mechanism_id: Local.get("managerInfo").mechanism_id,
        ...data
    }
    return request.get(path,param)
}


//查询教练
export function queryCoachByPhone(data:any){
    let path = "/user/coach/getByPhone"
    return request.get(path,data)
}

//绑定门店教练
export function bindMecCoach(id:any){
    let path = "/user/pushHistory/insert"
    let data = {
        context: "加入门店",
        large_type: "mechanism_coach",
        send_id: Local.get("current_mechanism").id,
        target_id: id
 

    }
    return request.post(path,data)
}


export function getManagerUserInfo(){
    let data = {
        id: Local.get("managerInfo").id,
    }
    let path = "/authorization/managerUser/findById"
    return request.get(path,data)
}

export function unBindMangerWx(){
    let data = {
        id: Local.get("managerInfo").id,
    }
    let path = "/authorization/managerUser/unbindwx"
    return request.post(path,data)
}



export function getCoachInfo(id:any){
    let data = {
        id
    }
    let path = "/user/coach/findById"
    return request.get(path,data)
}


//订单数据
export function mecOrderTodaySumData(data:any){
    let path = "/user/stat/orderTodaySumData"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        admin_id: 0,
        status:2,
        ...data
    }
    return request.get(path,param)
}

//订单类型数据
export function mecTypePrice(data:any){
    let path = "/user/stat/mecTypePrice"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        admin_id: 0,
        ...data
    }
    return request.get(path,param)
}

//订单类型数据
export function mecOrderDataByType(data:any){
    let path = "/user/stat/mecOrderNumAmount"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        admin_id: 0,
        ...data
    }
    return request.get(path,param)
}

//小店数据
export function mecShopData(data:any){
    let path = "/user/stat/mecShopData"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        ...data
    }
    return request.get(path,param)
}

//课程数据
export function mecCourseData(data:any){
    let path = "/user/stat/mecCourseData"
    let param:any = {
        mechanism_id: Local.get("current_mechanism").id,
        ...data
    }
    return request.get(path,param)
}

//获取门店信息
export function getMecInfo(){
    let path = "/user/mastermechanism/findById"
    let param:any = {
        id: Local.get("current_mechanism").id,
    }
    return request.get(path,param)
}


//修改门店
export function updateMechanism(data:any){
    let path = "/user/mastermechanism/update"
    return request.post(path,data)
}

//添加门店教练
export function addCoach(data:any){
    let path = "/user/coach/mechanism/insert"
    return request.post(path,data)
}

//商品入库
export function addInventory(data:any){
    let path = "/user/productSku/addInventory"
    return request.post(path,data)
}